import { render, staticRenderFns } from "./addChangePlan.vue?vue&type=template&id=1bf3e7ed&scoped=true&"
import script from "./addChangePlan.vue?vue&type=script&lang=js&"
export * from "./addChangePlan.vue?vue&type=script&lang=js&"
import style0 from "./addChangePlan.vue?vue&type=style&index=0&id=1bf3e7ed&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf3e7ed",
  null
  
)

export default component.exports